import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { Store } from '@ngxs/store';
import { MyAccountAction } from 'src/app/store/my-account/my-account.action';
import * as myAccountTypes from 'src/app/shared/types/my-account.types';
import { Observable } from 'rxjs';
import { MyAccountState } from 'src/app/store/my-account/my-account.state';
import { AranDrawerModalService } from '@aran-client/aran-web-ui-toolkit';
import { PagingConfig } from 'src/app/core/models/paging-config.model';
import { FilterService } from 'src/app/services/filter/filter.service';
import { routeMetaData } from 'src/app/shared/constants/route-metadata.constant';
import { appInfo } from 'src/app/shared/constants/app-info.constant';

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.scss'],
})
export class MyAccountComponent implements OnInit, AfterViewInit {
  @ViewChild('changePassword') changePassword!: TemplateRef<any>;
  @ViewChild('modalfieldsUpdate') modalfieldsUpdate!: TemplateRef<any>;

  routeMetaData = routeMetaData;
  appInfo = appInfo;
  menuItems: any[] = [];

  selectedIndexes: number[] = [];

  currentPage: number = 1;
  itemsPerPage: number = 10;
  maxSize: number = 5;
  totalItems: number = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  pagingConfig: { [key: string]: PagingConfig } = {};
  getAirportKey = (index: number) => `AirportHeliport-${index}`;
  getFirKey = (index: number) => `Airspace-${index}`;
  getScenarioKey = (index: number) => `Scenario-${index}`;

  filters: { [key: string]: string } = {
    Scenario: '',
    AirportHeliport: '',
    Airspace: '',
  };

  currentTemplate!: TemplateRef<any>;
  modalTitle: string = '';

  userDetail$: Observable<myAccountTypes.User | null> = this.store.select(
    MyAccountState.getUserDetail()
  );

  isLoading$: Observable<boolean> = this.store.select(
    MyAccountState.getIsLoading()
  );

  userDetail!: myAccountTypes.User | null;

  constructor(
    private store: Store,
    private aranDrawerModalService: AranDrawerModalService,
    private filterService: FilterService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.getDetails();
  }

  ngAfterViewInit() {
    this.menuItems = [
      {
        isVisible: true,
        name: 'Edit',
        icon: 'edit_note',
        iconType: 'material',
        type: 'action',
        action: () => this.update(),
      },
      {
        isVisible: true,
        name: 'Change Password',
        icon: 'lock',
        iconType: 'material',
        type: 'action',
        action: () => this.linkToChangePassword(),
      },
    ];

    this.cdr.detectChanges();
  }

  getDetails() {
    this.store.dispatch(new MyAccountAction.GetUserDetail()).subscribe();

    this.userDetail$.subscribe((data) => {
      this.selectedIndexes = data?.topics.map(() => 0) ?? [];
      this.userDetail = data;

      this.assignPagingConfig(data);
    });
  }

  assignPagingConfig(data: myAccountTypes.User | null) {
    data?.topics?.forEach((topic, index) => {
      const airportKey = this.getAirportKey(index);
      const firKey = this.getFirKey(index);
      const scenarioKey = this.getScenarioKey(index);

      this.filters[airportKey] = '';
      this.filters[firKey] = '';
      this.filters[scenarioKey] = '';

      this.pagingConfig[airportKey] = {
        id: airportKey,
        itemsPerPage: this.itemsPerPage,
        currentPage: this.currentPage,
        totalItems:
          topic.topicAreas?.filter((area) =>
            ['Aerodrome', 'Heliport'].includes(area.type)
          ).length || 0,
        footerTablePagination: true,
      };

      this.filterService.setPagingConfigValues(
        airportKey,
        this.pagingConfig[airportKey]
      );
      this.pagingConfig[airportKey] =
        this.filterService.getPagingConfigValues(airportKey);

      this.pagingConfig[firKey] = {
        id: firKey,
        itemsPerPage: this.itemsPerPage,
        currentPage: this.currentPage,
        totalItems:
          topic.topicAreas?.filter((area) => area.type === 'Airspace').length ||
          0,
        footerTablePagination: true,
      };

      this.filterService.setPagingConfigValues(
        firKey,
        this.pagingConfig[firKey]
      );
      this.pagingConfig[firKey] =
        this.filterService.getPagingConfigValues(firKey);

      this.pagingConfig[scenarioKey] = {
        id: scenarioKey,
        itemsPerPage: this.itemsPerPage,
        currentPage: this.currentPage,
        totalItems: topic.subTopics?.length || 0,
        footerTablePagination: true,
      };

      this.filterService.setPagingConfigValues(
        scenarioKey,
        this.pagingConfig[scenarioKey]
      );
      this.pagingConfig[scenarioKey] =
        this.filterService.getPagingConfigValues(scenarioKey);
    });
  }

  update() {
    this.modalTitle = 'Update Information';
    this.currentTemplate = this.modalfieldsUpdate;
    this.aranDrawerModalService.show();
  }

  linkToChangePassword = () => {
    this.modalTitle = 'Change Password';
    this.currentTemplate = this.changePassword;
    this.aranDrawerModalService.show();
  };

  onTabChanged(newIndex: number, itemIndex: number) {
    this.selectedIndexes[itemIndex] = newIndex;
  }

  onHandlePaginate(event: number, tableKey: string) {
    this.filterService.updatePagingConfigValue(tableKey, 'currentPage', event);
  }

  onHandlePageSize(newSize: number, tableKey: string) {
    this.filterService.updatePagingConfigValue(tableKey, 'currentPage', 1);
    this.filterService.updatePagingConfigValue(
      tableKey,
      'itemsPerPage',
      newSize
    );
  }

  applyFilter(key: string): void {
    this.filterService.updatePagingConfigValue(key, 'currentPage', 1);

    this.filterService.updatePagingConfigValue(
      key,
      'totalItems',
      this.totalItems
    );
  }

  resetFilter(key: string) {
    this.filters[key] = '';
    this.filterService.updatePagingConfigValue(key, 'currentPage', 1);
  }
}
